/* eslint-disable */
import type { CountryCodes, firebase } from '../../firebase/firestore';

export type IGuest_Gender = null | ('F' | 'M' | 'O');

export interface IGuest {
  address?: IGuest_Address;
  age?: 'A' | 'B' | 'C';
  category: string;
  contacts?: {
    email?: string;
    emailRecords?: MXRecords;
    phone?: string;
    website?: string;
  };
  createdAt: firebase.firestore.Timestamp;
  dietaryOptions?: ('dairyFree' | 'glutenFree' | 'halal' | 'kosher' | 'nutFree' | 'vegan' | 'vegetarian' | 'other')[];
  /**
   * @deprecated Use invitation.events instead.
   */
  events: {
    wedding: IGuest_Event;
  };
  gender?: IGuest_Gender;
  head?: null | string;
  id: string;
  invitation?: IGuest_Invitation;
  nameNormalized?: string;
  nameSearch?: string[];
  message?: string;
  name: string;
  notes?: string;
  order: number;
  table?: string;
  updatedAt?: firebase.firestore.Timestamp;
}
/**
 * This interface was referenced by `IGuest`'s JSON-Schema
 * via the `definition` "address".
 */
export interface IGuest_Address {
  adminArea?: string[];
  city?: string;
  country?: CountryCodes;
  name?: string;
  postalCode?: string;
  provider?: {
    id: string;
    type: 'google.places';
  };
  street?: string[];
}
/**
 * Email MX Records
 */
export interface MXRecords {
  /**
   * MX Priority Map
   */
  exchanges?: {
    [k: string]: number;
  };
  /**
   * Canonical Email Providers
   */
  providers?: string[];
}
export interface IGuest_Event {
  attending: null | boolean;
  invitation: string;
}
export interface IGuest_Invitation {
  events: {
    [k: string]: IGuest_EventNew;
  };
  note?: string;
  questions?: {
    [k: string]: IGuest_Question;
  };
}
export interface IGuest_EventNew {
  rsvp: Rsvp;
}
export interface IGuest_Question {
  answer: boolean | string;
}

export enum Rsvp {
  NO = 'no',
  PENDING = 'pending',
  YES = 'yes',
}
